import { useTranslation } from 'react-i18next';
import { DateTime, Duration } from 'luxon';
import { useSelector } from 'react-redux';
import { AnyObject, TestContext } from 'yup';
import { RootState } from '../../../../stores/Store';

function useNewConnectionScheduleDateUtils() {
  const [t] = useTranslation();
  const { companyConfigs } = useSelector((state: RootState) => state.newConnectionReducer);
  const today = DateTime.now().startOf('day');
  const tomorrow = today.plus({ day: 1 }).startOf('day');
  const maxStartDate = companyConfigs?.scheduleStartDateWindowLimit
    ? today.plus(Duration.fromISO(companyConfigs.scheduleStartDateWindowLimit)).startOf('day')
    : today.plus({ day: 1 }).startOf('day');
  const maxEndDate = companyConfigs?.scheduleEndDateWindowLimit
    ? today.plus(Duration.fromISO(companyConfigs.scheduleEndDateWindowLimit)).startOf('day')
    : today.plus({ month: 2 }).startOf('day');

  /**
   * Validates the date range
   * @param date
   * @param ctx
   * @param otherDate
   */
  const validateDateRange = (
    date: string | undefined,
    ctx: TestContext<AnyObject>,
    otherDate: 'currentDate' | 'startDate',
  ) => {
    if (date) {
      const dateObj = DateTime.fromISO(date);
      if (otherDate === 'startDate' && ctx.parent[otherDate]) {
        const otherDateObj = DateTime.fromISO(ctx.parent[otherDate]);
        if (dateObj.startOf('day') < otherDateObj.startOf('day')) {
          return ctx.createError({ message: t('common.inputValidations.endDateBeforeStartDate') });
        }
      }
    }
    return true;
  };

  return {
    validateDateRange,
    today,
    tomorrow,
    maxStartDate,
    maxEndDate,
  };
}

export default useNewConnectionScheduleDateUtils;
